var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9864 31.998C10.496 31.998 8.00339 32.0025 5.51299 31.998C3.90474 31.9934 2.46338 31.525 1.3298 30.2523C0.547351 29.3749 0.107358 28.3147 0.0401665 27.1334C-0.109388 24.5058 0.142037 21.917 1.07621 19.4539C1.863 17.377 3.12012 15.7798 5.2854 15.1903C6.36263 14.8979 7.3705 14.9047 8.31551 15.6747C9.26268 16.447 10.3269 17.0091 11.5017 17.3107C13.4199 17.7997 15.1733 17.3267 16.8293 16.2916C17.1739 16.0769 17.5294 15.8667 17.8393 15.5993C18.6261 14.923 19.5082 14.9139 20.4316 15.1126C22.3043 15.5171 23.6091 16.6892 24.4999 18.4372C25.4102 20.2239 25.8004 22.1615 25.9347 24.1539C26.0084 25.253 26.0366 26.3726 25.9282 27.467C25.6985 29.7816 23.8171 31.6689 21.6215 31.902C21.0688 31.9614 20.5118 31.9911 19.9569 31.9934C17.6356 32.0025 15.3142 31.998 12.9929 31.998H12.9864Z",
    fill: "#7E97B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00223 7.46754C5.01953 3.29375 8.36106 -0.0236613 12.5223 0.000127138C16.664 0.0239156 20.064 3.44729 19.9991 7.53241C19.932 11.7257 16.5948 15.0279 12.4552 14.9998C8.27455 14.9717 4.98277 11.6435 5.00007 7.46537L5.00223 7.46754Z",
    fill: "#7E97B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.2b938b01f2bac2b81dd67c359efbc7e5.svg";
export { ForwardRef as ReactComponent };